import PropTypes from 'prop-types';
import Icon from '../Icon';
import loadingImage from '../../assets/loading.gif';

import * as S from './style';

function Loading({
  color,
  fontSize = 48,
  w,
  pageLoading,
  fullscreen,
  spinning = true,
  ...props
}) {
  if (pageLoading) {
    return (
      <S.LoadingContainer>
        <img src={loadingImage} alt="loading" />
      </S.LoadingContainer>
    );
  }

  return (
    <S.Loading
      spinning={spinning}
      indicator={
        <Icon
          icon="spinner"
          width={`${fontSize}px`}
          height={`${fontSize}px`}
          color={color}
        />
      }
      w={w}
      {...props}
    />
  );
}

Loading.defaultProps = {
  color: 'blue',
  fontSize: 48,
};

Loading.propTypes = {
  color: PropTypes.string,
  fontSize: PropTypes.number,
  pageLoading: PropTypes.bool,
};

export default Loading;
